export default {
  setData(state, { payload }) {
    state.allData = payload?.data?.list || [];
  },
  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload?.data?.countdata, 10) || 0;
    state.totalPage = parseInt(payload?.data?.totalPage, 10) || 0;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
};
